var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 118,
    viewBox: "0 0 240 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.504,
    cy: 15.5914,
    r: 14.6305,
    fill: "#B2DDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5946H45.675C74.1459 15.5946 96.6374 23.5336 114.446 59.7929C126.322 83.9641 140.128 103.045 155.866 117.039H78.7525C47.7953 117.039 22.6936 103.843 12.4309 66.3162C5.5891 41.2983 1.44463 24.3915 0 15.5946Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 15.5946L194.326 15.5946C165.855 15.5946 143.364 23.5336 125.555 59.7929C113.679 83.9641 99.8735 103.045 84.1343 117.039L161.247 117.039C192.204 117.039 217.306 103.843 227.568 66.3162C234.41 41.2983 238.554 24.3915 239.999 15.5946H240Z",
    fill: "#1199E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c5033fe388490743ce4b4ddfb6712340.svg";
export { ForwardRef as ReactComponent };